var _symbol, _symbol2, _symbol3, _symbol4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgActionIconSprite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _symbol || (_symbol = /*#__PURE__*/React.createElement("symbol", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "arrow-bottom-download-icon",
    viewBox: "0 0 24 24",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 3V17M12 17L9 14M12 17L15 14M5 21H19",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol2 || (_symbol2 = /*#__PURE__*/React.createElement("symbol", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "pen-edit-icon",
    viewBox: "0 0 16 16",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.33335 11.999L6.39054 12.9418C6.1405 13.1919 5.80136 13.3324 5.44774 13.3324H4.33335M7.33335 11.999L12 7.33236M7.33335 11.999L4.00002 8.66569M4.00002 8.66569L3.05721 9.6085C2.80716 9.85855 2.66669 10.1977 2.66669 10.5513V11.6657M4.00002 8.66569L8.66669 3.99902M8.66669 3.99902L9.72388 2.94183C10.2446 2.42113 11.0888 2.42113 11.6095 2.94183L13.0572 4.38955C13.5779 4.91025 13.5779 5.75447 13.0572 6.27517L12 7.33236M8.66669 3.99902L12 7.33236M4.33335 13.3324H2.66669V11.6657M4.33335 13.3324L2.66669 11.6657",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol3 || (_symbol3 = /*#__PURE__*/React.createElement("symbol", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "pen-tiny-edit-icon",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5_3986)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.781333 12.7457C0.281202 13.2456 0.000151033 13.9238 0 14.631L0 15.9997H1.36867C2.07585 15.9995 2.75402 15.7185 3.254 15.2183L12.1493 6.323L9.67667 3.85034L0.781333 12.7457Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4298 0.569995C15.2675 0.407485 15.0747 0.278565 14.8625 0.190606C14.6503 0.102647 14.4228 0.057373 14.1931 0.057373C13.9634 0.057373 13.736 0.102647 13.5238 0.190606C13.3116 0.278565 13.1188 0.407485 12.9565 0.569995L10.6191 2.90799L13.0918 5.38066L15.4298 3.04333C15.5923 2.88099 15.7212 2.68821 15.8092 2.47601C15.8972 2.26382 15.9424 2.03637 15.9424 1.80666C15.9424 1.57696 15.8972 1.34951 15.8092 1.13731C15.7212 0.925114 15.5923 0.732335 15.4298 0.569995V0.569995Z",
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5_3986"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  }))))), _symbol4 || (_symbol4 = /*#__PURE__*/React.createElement("symbol", {
    id: "delete-edit-icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.6001 1.75C7.46203 1.75 7.3501 1.86193 7.3501 2V3.59459C7.3501 4.00881 7.01431 4.34459 6.6001 4.34459C6.18588 4.34459 5.8501 4.00881 5.8501 3.59459V2C5.8501 1.0335 6.6336 0.25 7.6001 0.25H10.4001C11.3666 0.25 12.1501 1.0335 12.1501 2V3.59459C12.1501 4.00881 11.8143 4.34459 11.4001 4.34459C10.9859 4.34459 10.6501 4.00881 10.6501 3.59459V2C10.6501 1.86193 10.5382 1.75 10.4001 1.75H7.6001Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.05029 3.59473C5.05029 3.18051 5.38608 2.84473 5.80029 2.84473L7.40029 2.84473C7.81451 2.84473 8.15029 3.18051 8.15029 3.59473C8.15029 4.00894 7.81451 4.34473 7.40029 4.34473L5.80029 4.34473C5.38608 4.34473 5.05029 4.00894 5.05029 3.59473Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.8501 3.59473C9.8501 3.18051 10.1859 2.84473 10.6001 2.84473H12.2001C12.6143 2.84473 12.9501 3.18051 12.9501 3.59473C12.9501 4.00894 12.6143 4.34473 12.2001 4.34473H10.6001C10.1859 4.34473 9.8501 4.00894 9.8501 3.59473Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5045 5.13372C16.3843 5.12462 16.2418 5.11399 16.08 5.1022L15.1684 15.0667C15.0269 16.5968 13.7267 17.7498 12.1912 17.7498H5.48201C3.91151 17.7498 2.59631 16.5449 2.49964 14.9772L1.90118 5.16386L1.89752 5.10384C1.74501 5.11498 1.61013 5.12505 1.49561 5.13372C1.35655 5.14425 1.24755 5.15272 1.17344 5.15855L1.06074 5.16752C0.647884 5.20104 0.286024 4.89353 0.252497 4.48068C0.218969 4.06783 0.527052 3.70592 0.939906 3.67239L1.05583 3.66317C1.13128 3.65724 1.24174 3.64865 1.38233 3.638C1.66349 3.61671 2.06531 3.58716 2.54879 3.55404C4.24069 3.43817 6.95901 3.27686 9.00004 3.27686C11.0411 3.27686 13.7594 3.43817 15.4513 3.55404C15.9348 3.58716 16.3366 3.61671 16.6177 3.638C16.7583 3.64865 16.8688 3.65724 16.9442 3.66317L17.0607 3.67244C17.4736 3.70596 17.7811 4.06783 17.7476 4.48068C17.714 4.89354 17.3518 5.20101 16.939 5.16749L16.8266 5.15855C16.7525 5.15272 16.6435 5.14425 16.5045 5.13372ZM9.75006 7.91882C9.75006 7.50461 9.41427 7.16882 9.00006 7.16882C8.58585 7.16882 8.25006 7.50461 8.25006 7.91882V13.108C8.25006 13.5222 8.58585 13.858 9.00006 13.858C9.41427 13.858 9.75006 13.5222 9.75006 13.108V7.91882ZM5.80011 8.03363C6.21432 8.03363 6.55011 8.36942 6.55011 8.78363V12.2431C6.55011 12.6573 6.21432 12.9931 5.80011 12.9931C5.3859 12.9931 5.05011 12.6573 5.05011 12.2431V8.78363C5.05011 8.36942 5.3859 8.03363 5.80011 8.03363ZM12.95 8.78363C12.95 8.36942 12.6142 8.03363 12.2 8.03363C11.7858 8.03363 11.45 8.36942 11.45 8.78363V12.2431C11.45 12.6573 11.7858 12.9931 12.2 12.9931C12.6142 12.9931 12.95 12.6573 12.95 12.2431V8.78363Z",
    fill: "currentColor"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgActionIconSprite);
export default __webpack_public_path__ + "static/media/action-icon-sprite.fcbb312765d7e7ebf2df83fda114a950.svg";
export { ForwardRef as ReactComponent };